
import React from "react";
const Total = (props)=>{
    let {mounthlyPayment,cashback,credit,percent,method}= props;

    return(
       <div className="total">
            <div className="indincators">
                <div className="first-wrap">
                    <div className="indicator-wrapper">
                        <p className="indicator-label">Ежемесячный платеж</p>
                        <p className="indicator-value pay">{method(Math.ceil(mounthlyPayment))} ₽</p>
                    </div>
                    <div className="indicator-wrapper">
                        <p className="indicator-label">Налоговый вычет</p>
                        <p className="indicator-value cashback">{method(Math.ceil(cashback))} ₽</p>
                    </div>
                </div>
                <div className="second-wrap">
                <div className="indicator-wrapper">
                        <p className="indicator-label">Сумма кредита</p>
                        <p className="indicator-value">{method(Math.ceil(credit))} ₽</p>
                    </div>
                    <div className="indicator-wrapper">
                        <p className="indicator-label">Процентная ставка</p>
                        <p className="indicator-value">{percent}%</p>
                    </div>
                </div>
            </div>
            <div className="button button_large green modalBtn" data-expand="overlay">Оставить заявку</div>
            <p className="text">Все расчеты являются приблизительными и при при каких условиях не могу быть публичной афертой. Ставки, платежи и иные условия определяются банком на основании обращения заемщика.
            </p>
       </div>
    )
}
export default Total